import { AxiosError, AxiosResponse } from 'axios';
import Core from '../core';
import { param } from 'jquery';

async function empwarnigandcomplaintlist(companyID: number, employeID: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `v2/empwarnigandcomplaintlist?empId=${employeID}&companyId=${companyID}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function updateEmpWarningStatus(payload: any) {
  const api = Core.getInstance().api();
  const data = await api.post(`v2/updateWarningempStatus`, payload);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function updateEmpComplaintStatus(payload: any) {
  const api = Core.getInstance().api();
  const data = await api.post(`v2/updateComplaintempStatus`, payload);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

export const warningcomplaintService = {
  empwarnigandcomplaintlist,
  updateEmpWarningStatus,
  updateEmpComplaintStatus,
};
